var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 240,
    viewBox: "0 0 576 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.801 -1.2002L248.763 28.7998L218.763 80.7616L166.801 50.7616L196.801 -1.2002Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288 28.7994C337.706 28.7994 378 69.0936 378 118.799C378 168.505 337.706 208.799 288 208.799C238.294 208.799 198 168.505 198 118.799C198 69.0936 238.294 28.7994 288 28.7994Z",
    fill: "#0061D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M346.201 60C354.485 60 361.201 53.2843 361.201 45C361.201 36.7157 354.485 30 346.201 30C337.917 30 331.201 36.7157 331.201 45C331.201 53.2843 337.917 60 346.201 60Z",
    fill: "#FFC700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.001 240C109.883 240 126.001 223.882 126.001 204C126.001 184.118 109.883 168 90.001 168C70.1187 168 54.001 184.118 54.001 204C54.001 223.882 70.1187 240 90.001 240Z",
    fill: "#DDDDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.001 25.7998C24.3147 25.7998 27.001 23.1135 27.001 19.7998C27.001 16.4861 24.3147 13.7998 21.001 13.7998C17.6873 13.7998 15.001 16.4861 15.001 19.7998C15.001 23.1135 17.6873 25.7998 21.001 25.7998Z",
    fill: "#FFC700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M460.801 175.8C469.085 175.8 475.801 169.084 475.801 160.8C475.801 152.516 469.085 145.8 460.801 145.8C452.517 145.8 445.801 152.516 445.801 160.8C445.801 169.084 452.517 175.8 460.801 175.8Z",
    fill: "#FFC700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M544.201 99.5996C560.77 99.5996 574.201 86.1682 574.201 69.5996C574.201 53.0311 560.77 39.5996 544.201 39.5996C527.633 39.5996 514.201 53.0311 514.201 69.5996C514.201 86.1682 527.633 99.5996 544.201 99.5996Z",
    fill: "#DDDDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M396 160.799C396 87.8976 455.099 28.7988 528 28.7988V160.799H396ZM486 208.799V166.799H528C528 189.995 509.196 208.799 486 208.799ZM534 160.799V118.799H576C576 141.995 557.196 160.799 534 160.799ZM0.000976562 160.799C0.000976562 87.8976 59.0992 28.7994 132.001 28.7994V160.799H0.000976562ZM90.001 208.799V166.799H132.001C132.001 189.995 113.197 208.799 90.001 208.799ZM138 160.799V118.799H180C180 141.995 161.196 160.799 138 160.799Z",
    fill: "#0061D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 151.8L40.9816 136.8L55.9816 162.78L30.001 177.78L15.001 151.8ZM416.491 198.478L437.704 219.691L416.491 240.905L395.278 219.691L416.491 198.478Z",
    fill: "#FFC700"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M352.201 161.399L372.986 173.399L360.986 194.184L340.201 182.184L352.201 161.399ZM537.001 203.999L552.589 194.999L561.589 210.587L546.001 219.587L537.001 203.999Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.a2c96ee6c734d87bf02215ac82ad85b0.svg";
export { ForwardRef as ReactComponent };